import React, {useEffect, useState, useContext, useRef} from 'react';
import "./TopBar.sass";
import "./TopBar.css";
import {
    FiArrowLeft,
    FiCheck,
    FiTrash,
    FiSlash,
    FiTablet
} from 'react-icons/fi';
import {useGlobal} from "reactn";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import clearMessageApi from "../../../actions/clearMessage";
import closeSessionApi from "../../../actions/closeSession";
import getRoom from "../../../actions/getRoom";
import blockUserApi from "../../../actions/blockUser";
import moment from "moment";
import MasterConstant from "../../../constants/MasterConstant";
import changeStatusChatbotApi from "../../../actions/changeStatusChatbot";
import { AppContext } from '../../../context/AppContext';
import {Image, Tooltip, OverlayTrigger} from "react-bootstrap";
import {useDispatch} from "react-redux";
import icons from "../../../assets";
import { Switch, Tag } from 'antd';
import Config from "../../../config";
import Actions from "../../../constants/Actions";
import { RiCheckDoubleFill } from "react-icons/ri";

const TopBar = ({back, loading, reloadRooms}) => {
    const room = useSelector(state => state.io.room);
    const user = useGlobal('user')[0];
    const Setting = useGlobal('settings')[0];
    const history = useHistory();
    const [checkedChatbot, setCheckedChatbot] = useState(false);
    const dispatch = useDispatch();

    const chatMode = useGlobal('chatMode')[0];
    const livechatColor = useGlobal('livechatColor')[0];
    const chatSession = useSelector(state => state.io.chat_session);
    const [isBlock, setIsBlock] = useState(false);
    const [showButtonCloseSession, setShowButtonCloseSession] = useState(false);
    const { showAlertAction, showConfirmAction, i18n } = useContext(AppContext)

    const [openInfo, setInfo] = useGlobal('openInfo');

    let userChat = room?.owner;

    if (userChat && !userChat.firstName) {
        userChat = {...userChat, firstName: 'Deleted', lastName: 'User'};
    }

    useEffect(() => {
        room?.enable_bot === 1 ? setCheckedChatbot(true) : setCheckedChatbot(false);
    }, [room]);

    useEffect(() => {
        if(userChat){
            setIsBlock(userChat.isBlocked);
        }
    }, [userChat]);

    useEffect(() => {
        if(chatMode !== 'client' && room){
            if(room.session_status === 'active'){
                setShowButtonCloseSession(true);
            }
            else{
                setShowButtonCloseSession(false);
            }
        }
    }, [room, chatMode]);

    useEffect(() => {
        if(chatMode !== 'client' && room && room && room._id === chatSession.room_id) setShowButtonCloseSession(true);
    }, [chatSession, room, chatMode]);

    const getTitleRoom = () => {
        let title = '';

        if(chatMode === 'client'){
            title = room.channel.nameApp || '';
        }

        else if(room && room.isGroup){
            title = room.room_name || '';
        }

        else if(room && userChat){
            let userName = ((room.length > 0 && room.customerName !== '') ? room.customerName : `${userChat.firstName} ${userChat.lastName}`);
            title = userName ? userName.substr(0, 50) : '';
        }

        return `${title}${title.length > 55 ? '...' : ''}`;
    }

    const handleIconChannel = (source) => {
        if(source === 'facebook'){
            return icons.Facebook;
        }
        else if(source === 'zalo'){
            return icons.Zalo;
        }
        else{
            return icons.ClientChat;
        }
    }

    const IconCustomer = () => {
        let icon = '';
        let title = '';

        if(!userChat){
            return icon;
        }

        if(userChat.customerId){
            icon = icons.Customer;
            title = i18n.t('customer');
        }
        else if(userChat.cpoCustomerId){
            icon = icons.CpoCustomer;
            title = i18n.t('lead');
        }

        if(icon !== ''){
            return (<OverlayTrigger placement="bottom" overlay={generateTooltip(title)}>
                <span className="icon-user-room">
                    <Image width="16" src={icon}/>
                </span>               
            </OverlayTrigger>)
        }

        return icon;
    }

    const toggleInfoOn = () => {
        setInfo(true);
    };

    const toggleInfoOff = () => {
        setInfo(false);
    };

    const Online = ({userChat}) => {
        const onlineUsers = useSelector(state => state.io.onlineUsers);
        const prevStatusRef = useRef(false);
        const [lastOnline, setLastOnline] = useState(null);

        useEffect(() => {
            if(userChat){
                if (prevStatusRef.current && onlineUsers.filter(u => u.id === userChat._id).length === 0) setLastOnline(moment().valueOf());
                prevStatusRef.current = onlineUsers.filter(u => u.id === userChat._id).length > 0;
            }
        }, [onlineUsers, userChat]);
        
        if (lastOnline) return `${i18n.t('online')}: ${moment(lastOnline).fromNow()}`;

        if(!room) return '';

        return `${i18n.t('online')}: ${MasterConstant.timeSince(room.lastUpdate, i18n, 'today')}`;
    };

    // const getStatus = () => {
    //     if (room.isGroup) return null;
    //     if (onlineUsers.filter(u => u.id === userChat._id && u.status === 'busy').length > 0) return 'busy';
    //     if (onlineUsers.filter(u => u.id === userChat._id && u.status === 'online').length > 0) return 'online';
    //     if (onlineUsers.filter(u => u.id === userChat._id && u.status === 'away').length > 0) return 'away';
    //     return null;
    // };

    // const ContentPin = () => {
    //     return MasterConstant.contentReply(room.pinMessage, 300);
    // };

    // const unPinMessage = async () => {
    //     const res = await updateGroup({
    //         type: 'single-data', roomId: room._id, data: null, field : 'pinMessage'
    //     });
    // }

    const handleActionClearMessage = () => {
        showConfirmAction(handleClearMessage, `${i18n.t('confirm_delete_chat_history')}?`);
    }

    const handleActionBlockRoom = () => {
        showConfirmAction(handleBlockChat, isBlock ? `${i18n.t('confirm_unblock_user')}?` : `${i18n.t('confirm_block_user')}?`);
    }

    const handleClearMessage = () => {
        clearMessageApi({roomId: room._id}).then(async (res) => {
            if(res.data){
                reloadRooms();
                showAlertAction('success', res.data.message);
                await history.replace('/');
            }
        }).catch(err => console.log('clearMessageApi', err));
    }

    const handleBlockChat = () => {
        blockUserApi({userId: userChat._id, isBlocked: !isBlock}).then(async (res) => {
            if(res.data.error === 0){
                let elmAction = document.getElementsByClassName('action-event');
                if(isBlock){
                    for await (let item of elmAction) {
                        item.classList.remove('prevent-events')
                    }
                }
                else{
                    for await (let item of elmAction) {
                        item.classList.add('prevent-events')
                    }
                }
                showAlertAction('success', res.data.message);
                setIsBlock(!isBlock);
                reloadRooms();
            }
        }).catch(err => console.log('blockUserApi', err));
    }

    const getColorBlockIcon = () => {
        return isBlock ? '#dd2c00' : '#666666';
    }

    const generateTooltip = (content) => {
        return <Tooltip>{content}</Tooltip>;
    }

    const changeStatusChatbot = (checked) => {
        let status = checked ? 1 : 0;

        changeStatusChatbotApi({room_id: room._id, status}).then((res) => {
            let response = res.data;
            if(!response.error){
                setCheckedChatbot(status ? true : false);
                showAlertAction('success', response.message);
                reloadRooms();
            }
        }).catch(err => console.log('changeStatusChatbotApi', err));
    }

    const ChatbotStatus = () => {
        return (
            <div className="button chatbot-enable">
                <Switch checkedChildren="Chatbot" unCheckedChildren="Chatbot" onChange={changeStatusChatbot} checked={checkedChatbot}/>
            </div>
        )
    }
    
    const Picture = ({user = {}, room}) => {

        let brand = useGlobal('brand')[0];
    
        let firstName = user.firstName || "User";

        if(chatMode === 'client'){
            if(room?.channel?.avatar){
                return <img className="picture" src={room.channel.avatar} alt="Avatar Channel"/>;     
            }
            else{
                const channelName = room.channel.nameApp;
                return <div className="img">{channelName.substr(0,1).toUpperCase()}</div>
            }
        }

        if (room && room.isGroup){
            return <img className="picture" src={room.room_avatar} alt="Avatar Group"/>;        
        }
        
        if (room && room.shieldedID){
            return <img className="picture" src={`${Config.url || ''}/api/images/${room?.shieldedID}/256/${brand}`} alt="Avatar User"/>;        
        }
        else
            return <div className="img">{firstName.substr(0,1).toUpperCase()}</div>;
    };

    const closeSessionByStaff = () => {
        showConfirmAction(handleCloseSession, `${i18n.t('confirm_close_session')}?`);
    }

    const handleCloseSession = () => {
        closeSessionApi({room_id: room._id}).then((res) => {
            let response = res.data;
            if(!response.error){
                showAlertAction('success', response.message);
                getRoom(room._id).then(res => {
                    let dataRoom = res.data.room;
                    dispatch({type: Actions.SET_ROOM, room: dataRoom});
                    dispatch({type: Actions.SET_MESSAGES, messages: dataRoom.messages});
                    dispatch({type: Actions.MESSAGES_REMOVE_ROOM_UNREAD, roomID: room._id});
                }).catch(err => {
                    dispatch({type: Actions.SET_ROOM, room: null});
                    dispatch({type: Actions.SET_MESSAGES, messages: []});
                });
            }
        }).catch(err => console.log('closeSessionApi', err));
    }

    return (
        <>
        <div className={`top-bar uk-flex uk-flex-between uk-flex-middle`} style={{ backgroundColor: livechatColor }}>
            <div className="nav uk-flex uk-flex-middle">
                <div className="button mobile" onClick={() => back()}>
                    <FiArrowLeft/>
                </div>
                {!loading &&
                <div className="uk-flex uk-flex-middle">
                    <div className="profile conversation">
                        <Picture user={userChat} room={room}/>
                        {chatMode !== 'client' && room &&
                            <Image className="social-icon" width="20" src={handleIconChannel(room.source)}/>
                        }
                    </div>
                    {/* {getStatus() && <div className={`dot ${getStatus()}`}/>} */}
                </div>
                }
                {!loading &&
                <div className="text">
                    <div className="title room-title">
                        {getTitleRoom()}
                        {<IconCustomer/>}
                    </div>
                    {chatMode === 'server' &&
                        <div className="message">{(room && room.isGroup) ? `${room.people.length} thành viên` :
                            <Online userChat={userChat}/>}
                        </div>
                    }
                </div>
                }
            </div>

            <div className="nav list-action-conversation">
                {Setting && Setting.chatbot_enable && room && room.channel?.enable_bot && !room.isGroup
                ? <div className="list-action-conversation--item">
                    <ChatbotStatus/>
                </div> 
                : <></>}
                
                {showButtonCloseSession && (
                    <div className="list-action-conversation--item">
                        <OverlayTrigger placement="bottom" overlay={generateTooltip('Hoàn thành phiên chat')}>
                            <Tag type="default" style={{ cursor: 'pointer', padding: '4px 5px', background: '#f0f3fb' }} onClick={() => closeSessionByStaff()} icon={<RiCheckDoubleFill color="green" size="22"/>} />
                        </OverlayTrigger>
                    </div>
                )}

                <div className="list-action-conversation--item">
                    <OverlayTrigger placement="bottom" overlay={generateTooltip(i18n.t('delete_chat_history'))}>
                        <span className="icon-remove-chat" onClick={() => handleActionClearMessage()}><FiTrash/></span>
                    </OverlayTrigger>
                </div>

                {(room && room.source !== 'client') &&
                    <div className="list-action-conversation--item">
                        <OverlayTrigger placement="bottom" overlay={generateTooltip(isBlock ? i18n.t('unblock_user') : i18n.t('block_user'))}>
                            <span className="icon-slash-chat" style={{ color: getColorBlockIcon()}}
                                onClick={() => handleActionBlockRoom()}>
                                {<FiSlash/>}
                            </span>
                        </OverlayTrigger>
                    </div>
                }

                <div className="list-action-conversation--item">
                    {openInfo && (<div className={`button active`} onClick={() => toggleInfoOff()}>
                        <FiTablet/>
                    </div>)}
                    {!openInfo && (<div className={`button`} onClick={() => toggleInfoOn()}>
                        <FiTablet/>
                    </div>)}
                </div>
            </div>
            {/* {room.pinMessage && (
                <div className="pin_message">
                    <span className="img_pin_message">
                        <BiMessageRoundedDetail />
                    </span>
                    <div className="block_pin_message">
                        <p><strong>Message from {room.pinMessage.author.firstName} {room.pinMessage.author.lastName} : </strong></p>
                        <span><ContentPin/></span>
                    </div>
                    <div className="uk-inline action_pin_message">
                        <div className="button button_hover cursor-pointer" type="button">
                            <FiMoreHorizontal/>
                        </div>
                        <div data-uk-dropdown="mode: click; offset: 5; boundary: .top-bar; pos: bottom-right"
                            className="uk-dropdown  action_member action_show">
                            <div className="link color-red" onClick={unPinMessage}><div className="icon"><AiOutlinePushpin/></div> Unpin </div>
                        </div>
                    </div>
                </div>
            )} */}
        </div>
        </>
    );
}

export default TopBar;
